import React, { useState, useEffect } from "react";
//import DatePicker from "react-horizontal-datepicker";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import AppointmentStep5 from "./Step5";
import moment from "moment";
import Moment from "react-moment";
import { v4 as uuidv4 } from 'uuid';
import Accordion from 'react-bootstrap/Accordion';
//import slotData from './data.json';
import { slotSelection } from "../../redux/actions/appointmentActions";


//import ReactHorizontalDatePicker from 'react-horizontal-strip-datepicker'
import 'react-horizontal-strip-datepicker/dist/ReactHorizontalDatePicker.css'
import PatientInfo from "./PatientInfo";

function AppointmentStep4() {

  let AccessToken = localStorage.getItem("AccessToken");
  let NodeServerHost = process.env.REACT_APP_API_URL;
  let CareCode = localStorage.getItem("CareCode");
  let OperatingId = process.env.REACT_APP_OperatingId;
  let orgId = localStorage.getItem("orgId");

  // const selectedDay = (val) => {
  //   console.log(val);
  // };

  const { handleSubmit } = useForm();

  const [showStepFive, setShowStepFive] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    setShowStepFive((value) => !value);
  };
  
  const reduxData = useSelector((state) => state)

  const bundle = {
    resourceType: "Bundle",
    id: uuidv4(),
    type: "transaction",
    entry: []
  }

  reduxData.appointmentType.location?.map((resource) => {
    return bundle.entry.push({resource: resource})
  })
  //console.log(temp)
  reduxData.appointmentType.healthcareService?.map((resource) => {
    return bundle.entry.push({resource: resource.value})
  })
  //console.log(bundle)

  const requestOptions = {
    method: 'POST',
    headers: { 
      OrganizationId: orgId,
      CareCode: CareCode,
      OperatingId: OperatingId,
      Authorization: "Bearer " + AccessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bundle)
  };

  const [hasError, setHasError] = useState(false)
  useEffect(() => {
    
  }, []);
  //console.log(slotData);
  // console.log(hasError);

  // let startTime = moment("10:15", 'HH:mm');
  // let endTime = moment("12:00", 'HH:mm');
  // if (endTime.isBefore(startTime)) {
  //     endTime.add(1, 'day');
  // }
  // const [timeStops, setTimeStops] = useState([])
  // let slotIntervalSetting = 15;
  // while (startTime <= endTime) {
  //     setTimeStops(...timeStops, new moment(startTime).format('hh:mm A'));
  //     startTime.add(slotIntervalSetting, 'minutes');
  // }
  // console.log(timeStops);

  // var x = 5; //minutes interval
  // var times = []; // time array
  // var tt = 0; // start time
  // var ap = ['AM', 'PM']; // AM-PM

  // //loop to increment the time and push results in array
  // for (var i=0;tt<24*60; i++) {
  //   var hh = Math.floor(tt/60); // getting hours of day in 0-24 format
  //   var mm = (tt%60); // getting minutes of the hour in 0-55 format
  //   times[i] = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
  //   tt = tt + x;
  // }

  // console.log(times);

  // let start = "10:15";
  // let end = "14:00";
  function getTimesArray(start, end) {
    let startTime = moment(start, 'HH:mm');
    let endTime = moment(end, 'HH:mm');
    if (endTime.isBefore(startTime)) {
        endTime.add(1, 'day');
    }
    let timeStops = [];
    let slotIntervalSetting = 15;
    while (startTime <= endTime) {
        timeStops.push(new moment(startTime).format('hh:mm A'));
        startTime.add(slotIntervalSetting, 'minutes');
    }
    return timeStops;
  }
  
  const [appointments, setAppointments] = useState(null)
  const [locations, setLocations] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  useEffect( () => {
    (async () => {
      
      await fetch(NodeServerHost + `/Appointment/Slot`, requestOptions)
      .then((response) => response.json())
      .then((responseData) => {
        setIsLoading(false);
        //console.log(responseData);
        setLocations([]);
        responseData?.map((item) => {
          
          
          const sortService = item.resourceDetails.map((item) => {
            if(item.resourceType === "HealthcareService"){
              return item
            }
            return null;
          })

          const sortLocationName = item.resourceDetails.map((item) => {
            if(item.resourceType === "Location"){
              return item.resourceName
            }
            return null;
          })
          
          const appointmentsData = sortService.filter(element => {
            return element !== null;
          });
          
          const locationName = sortLocationName.filter(element => {
            return element !== null;
          });

          setAppointments(appointmentsData)
          

          let location = [];
          //console.log(item.locationTimeZone)
          item.slotDetails.map((itemChild) => 
            // itemChild.scheduleAvailable.map((times) => 
            //   //console.log(dates.startDateTime + " - " + dates.endDateTime)
            //   setDates(dates => [...dates, {start: moment(times.startDateTime).format('hh:mm A'), end: moment(times.endDateTime).format('hh:mm A')}])
            // )
            //console.log(item.locationTimeZone)
            //console.log(itemChild)
            location.push({sloter:itemChild, locationTimezone:item.locationTimeZone, locationName:locationName[0]})
            //alert(itemChild)
          )
          setLocations(dates => [...dates, location]);
          return item;
        })
      })
      .catch(err => setHasError(true))

      
    })();
    
  }, []);

  //console.log(isLoading)
  console.log(locations)
  // console.log(appointments)

  let locationwise = [];
  locations.map((dates, index) => {
    let location = [];
    console.log(dates);
    dates.map((timing, index) => {
      //console.log(timing.slotDate)
      let slots = [];
      timing.sloter.scheduleAvailable.map((times) => {
        //console.log(timing.slotDate + ": " + times.startDateTime + " - " + times.endDateTime)
        let start = moment(times.startDateTime).format('HH:mm');
        let end = moment(times.endDateTime).format('HH:mm');
        // console.log("Start" + index + ": " + start);
        // console.log("End" + index + ": " + end);
        console.log(times.scheduleIds)
        slots.push({slots: getTimesArray(start, end), scheduleLocation:times.scheduleIds[0].location, scheduleService:times.scheduleIds[0].healthcareService})
        return times;
      })
      let dateCalendar = moment(timing.sloter.slotDate).format("YYYY-MM-DD")
      location.push({locationTimezone: timing.locationTimezone, locationName:timing.locationName, date: dateCalendar, slots});
      return timing;
    })
    locationwise.push(location)
    return dates;
  })
  console.log(locationwise);

    // const DateArr = dates.map((timing) =>{ 
    //   //console.log(timing.slotDate)
    //   return timing
    // })
  
  
  //let Slots = getTimesArray(start, end);
  //console.log(Slots)

  const today = moment();
  const daysArray = Array(6).fill().map(
    () => today.add(1, 'd').format('YYYY-MM-DD')
  );
  
  // const initialState = [
  //   {id: 1, country: 'Austria'},
  //   {id: 2, country: 'Belgium'},
  //   {id: 3, country: 'Canada'},
  // ];

  const [dataDates, setDataDates] = useState(daysArray);

  const NextDates = () => {
    let lastDate = dataDates.pop();
    //console.log(dataDates);
    const nextToday = moment(lastDate);
    const daysArrayNext = Array(6).fill().map(
      () => nextToday.add(1, 'd').format('YYYY-MM-DD')
    );
    const newState = daysArrayNext.map((obj, index) => {
        return obj
    });
    setDataDates(newState);
  };

  const PrevDates = () => {
    let firstDate = dataDates[0];
    //console.log(dataDates[0]);
    const prevYesterday = moment(firstDate);
    const daysArrayPrev = Array(6).fill().map(
      () => prevYesterday.subtract(1, 'd').format('YYYY-MM-DD')
    );
    daysArrayPrev.sort((a,b) => a?.localeCompare(b))
    const newState = daysArrayPrev.map((obj, index) => {
        return obj
    });
    setDataDates(newState);
  };

  function convertLocalToUTC(dt, dtFormat) {
    return moment(dt, dtFormat).utc().format('YYYY-MM-DDTHH:mm:ss');
  }

  const SelectedSlot = (e) => {
    //console.log(e.currentTarget.dataset.slot);
    let locationScheduleId = e.target.parentNode.getAttribute("data-schedule-location");
    let serviceScheduleId = e.target.parentNode.getAttribute("data-schedule-service");

    let startTime = moment(e.target.parentNode.getAttribute("data-date")+ " " + e.currentTarget.dataset.slot).format('YYYY-MM-DDTHH:mm');
    let startTimeConvertToUTC = convertLocalToUTC(startTime, 'YYYY-MM-DDTHH:mm:ss') + e.target.parentNode.getAttribute("data-timezone");
    
    let endTime = moment(e.target.parentNode.getAttribute("data-date")+ " " + e.currentTarget.dataset.slot).format('YYYY-MM-DDTHH:mm') ;
    let endTimeConvertToUTC = convertLocalToUTC(endTime, 'YYYY-MM-DDTHH:mm:ss');
    let endTimeSlotInterval = moment(endTimeConvertToUTC, "DD-MM-YYYYThh:mm").add(15, 'minutes').format('YYYY-MM-DDTHH:mm:ss') + e.target.parentNode.getAttribute("data-timezone");

    e.currentTarget.classList.remove('active');
    e.currentTarget.classList.add('active');
    // console.log(locationScheduleId);
    // console.log(serviceScheduleId);
    dispatch(slotSelection({locationScheduleId: locationScheduleId, serviceScheduleId:serviceScheduleId, slotStart:startTimeConvertToUTC, slotEnd:endTimeSlotInterval }));
  }
  
  const [activeKey, setActiveKey] = useState(null)
  useEffect(() => {
    const timer = setTimeout(() => {
      setActiveKey(0)
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  if(reduxData.appointmentType.location !== null){
    if (showStepFive === false) {
      return (
        <div className="row justify-content-md-center">
          <div className="appointmentBackground"></div>
          
          <div className="col col-lg-5">
            <h3 className="mt-5 mb-3">Book a Slot</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="card pb-3 p-3 boxviewtransperant scrollbox">
                <PatientInfo></PatientInfo>
                
                <div className="book-appts">
                  {isLoading === true && (
                    <div className="text-center"><div class="spinner-border" role="status"></div>Fetching Slots</div>
                  )}
                  {isLoading === false && (
                    <Accordion defaultActiveKey="0">
                    {reduxData.appointmentType.healthcareService.map((service, index) => (
                      //console.log("tes " + index)
                      <Accordion.Item eventKey={index}>
                      <Accordion.Header>{service.value?.name}</Accordion.Header>
                      <Accordion.Body>
                      <div className="row mt-3 border-bottom pb-2">
                          <div className="col-md-4">
                            <h5 className="leftHeadingPatch">{service.value?.name}</h5>
                          </div>
                          <div className="col-md-8 position-relative calendarscroll pe-4">
                            <div className="row">
                              <a href="javacript:void(0)" className="arrowLeft" onClick={PrevDates}><i className="fa fa-caret-left"></i></a>
                              <a href="javacript:void(0)" className="arrowRight" onClick={NextDates}><i className="fa fa-caret-right"></i></a>
                              {dataDates.map(day => (
                                <div className="col-md-2 p-0">
                                  <h6 className="text-center caldate">
                                    <Moment className="text-day text-uppercase" format="ddd">{day}</Moment><br></br>
                                    <Moment className="text-date" format="DD">{day}</Moment><br></br>
                                    <Moment className="text-month text-uppercase" format="MMM">{day}</Moment>
                                  </h6>
                                </div>
                              ))}
                            </div>
                          </div>
                            <div className="col-md-12 border-top pt-3 pb-3">
                                {/* <div className="col-md-4">
                                  <h6>{location.name}</h6>
                                </div> */}
                                {locationwise.map(date => (
                                  <div className="row">
                                    <div className="col-md-4">
                                    <h6>{date[0]?.locationName}</h6>
                                    </div>
                                    <div className="col-md-8 position-relative slotview pe-4">
                                      <div className="row">
                                      {date.map(item => (
                                        <div className="col-md-2 p-0">
                                          {item.slots.map((childslot, i) => (
                                            //console.log(childslot.scheduleService)
                                            <ul className="grid-slots" data-timezone={item.locationTimezone} data-date={item.date} data-schedule-location={childslot.scheduleLocation} data-schedule-service={childslot.scheduleService}>
                                            {childslot.slots.map((childslotItem, i) => (
                                              //console.log(childslotItem)
                                              <li onClick={SelectedSlot} data-slot={childslotItem} key={childslot.scheduleIds}>{childslotItem}</li>
                                            ))}
                                            </ul>
                                          ))}
                                        </div>
                                      ))}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    ))}
                  </Accordion>
                  )}
                  
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <button
                    className="btn btn-secondary btn-block"
                    style={{ width: "100%" }}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      );
    }else{
      return (
        <AppointmentStep5 />
      )
    }
  }else{
    return (
      <AppointmentStep5 />
    )
  }

  
}

export default AppointmentStep4;
